import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=b2bbb97e&scoped=true"
import script from "./tags.vue?vue&type=script&lang=ts"
export * from "./tags.vue?vue&type=script&lang=ts"
import style0 from "./tags.vue?vue&type=style&index=0&id=b2bbb97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbb97e",
  null
  
)

export default component.exports